import { connect } from 'react-redux'
import { StoreQuickSearchComponent } from './StoreQuickSearchComponent'
import { injectIntl } from 'react-intl'
import type { SearchParams } from 'shared/store/store-locator'
import {
    clearSearch,
    geocodingError,
    loading,
    search,
    selectRestaurant
} from 'shared/store/store-locator'
import { push } from 'connected-react-router'
import type { EventMetadata } from 'shared/store/metadata'
import { eventMetadata } from 'shared/store/metadata'
import type { Dispatch } from 'redux'
import type { RootState } from 'shared/store/reducers'
import type { RestaurantShortDTO } from 'shared/types'

const mapStateToProps = (state: RootState) => {
    const {
        address,
        restaurants,
        visitedRestaurants
    } = state.storeLocatorPageState

    const hasVisitedRestaurants =
        visitedRestaurants && visitedRestaurants.length > 0

    const hasSearchBeenMade = address !== null

    const displayedRestaurants =
        (hasSearchBeenMade ? restaurants : null) ||
        (hasVisitedRestaurants ? visitedRestaurants : null)

    const numberOfResults = displayedRestaurants
        ? displayedRestaurants.length
        : 0

    const n = 3
    const nFirstDisplayedRestaurants = displayedRestaurants
        ? displayedRestaurants.filter((restaurant, index) => index < n)
        : null

    const resultsTitleKey = hasSearchBeenMade
        ? 'search'
        : hasVisitedRestaurants
        ? 'visited'
        : null

    const moreResults = numberOfResults > n

    return {
        ...state.storeLocatorPageState,
        restaurants: nFirstDisplayedRestaurants,
        numberOfResults,
        moreResults,
        resultsTitleKey
    }
}

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
    search: (params: SearchParams) => dispatch(search(params, 'search')),
    setLoading: (isLoading: boolean) => dispatch(loading(isLoading)),
    geocodingError: (error: boolean) => dispatch(geocodingError(error)),
    clearSearch: () => dispatch(clearSearch()),
    selectRestaurant: (r: RestaurantShortDTO) => dispatch(selectRestaurant(r)),
    navigate: (to: string) => dispatch(push(to)),
    sendMeta: (meta: EventMetadata) => dispatch(eventMetadata(meta))
})

// prettier-ignore
const StoreQuickSearchContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(injectIntl(StoreQuickSearchComponent))

export default StoreQuickSearchContainer
